import { render, staticRenderFns } from "./IpoPortfolioGroup.vue?vue&type=template&id=49273fd9"
import script from "./IpoPortfolioGroup.vue?vue&type=script&lang=js"
export * from "./IpoPortfolioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports